// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  remote_domain: 'http://192.168.1.6:8003',
  mapboxKey: 'pk.eyJ1IjoieGluZ2tvbmdkYWRhbyIsImEiOiJja2o5ZWhwcnExb3ZyMnBueWhwdGs1enZtIn0.Cn5umRC36CQdCbov5Q7oYQ',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
